import React from "react";
import { Form } from "react-bootstrap";
import { useSyncedField } from "../../components/Sidebar";

const RoleBasicDetails = () => {
    const [name, setName] = useSyncedField("name", "");
    const [description, setDescription] = useSyncedField("description", "");

    return (
        <div className="p-3">
            <Form>
                <Form.Group className="mb-3">
                    <Form.Label>
                        Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                        placeholder="Role name"
                    />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Write a short note…"
                    />
                </Form.Group>
            </Form>
        </div>
    );
};

export default RoleBasicDetails;
